import { createI18n } from 'vue-i18n'

import enGB from './locales/en-GB.json'

export const DEFAULT_LOCALE = 'en-GB'

export type MessageSchema = typeof enGB

// One language in version 1 (MRS 9). Every user-facing string is a key here;
// the ESLint rule @intlify/vue-i18n/no-raw-text refuses a bare literal.
export const i18n = createI18n<[MessageSchema], typeof DEFAULT_LOCALE>({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { [DEFAULT_LOCALE]: enGB },
})
